/* Nocna Skóra — theme.js
   Sans dépendance. Tiroir panier AJAX (Cart API + Section Rendering API), quantités, variantes,
   galerie, CTA collant. Aucun tracking, aucune donnée simulée. */
(function () {
  'use strict';

  var NS = window.NS || {};
  var routes = NS.routes || { cart: '/cart', cart_add: '/cart/add.js', cart_change: '/cart/change.js', cart_json: '/cart.js' };
  var strings = NS.strings || {};
  var drawer = document.querySelector('[data-cart-drawer]');
  var lastFocus = null;
  var busy = false;

  function qs(sel, root) { return (root || document).querySelector(sel); }
  function qsa(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }

  /* ---------- Money (affichage uniquement ; les montants réels viennent de Shopify) ---------- */
  function money(cents) {
    var cur = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'PLN';
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'pl', { style: 'currency', currency: cur }).format(cents / 100);
    } catch (e) {
      return (cents / 100).toFixed(2) + ' ' + cur;
    }
  }

  /* ---------- Cart sections ---------- */
  function sectionIds() {
    var ids = [];
    qsa('[data-cart-section]').forEach(function (el) {
      var id = el.getAttribute('data-section-id');
      if (id && ids.indexOf(id) === -1) ids.push(id);
    });
    return ids;
  }

  function applySections(sections) {
    if (!sections) return;
    Object.keys(sections).forEach(function (id) {
      var live = qs('[data-cart-section][data-section-id="' + id + '"]');
      if (!live || !sections[id]) return;
      var doc = new DOMParser().parseFromString(sections[id], 'text/html');
      var fresh = doc.querySelector('[data-cart-section][data-section-id="' + id + '"]');
      if (fresh) live.innerHTML = fresh.innerHTML;
    });
  }

  function setCount(count) {
    qsa('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
      el.hidden = !(count > 0);
    });
  }

  function setLoading(on) {
    busy = on;
    qsa('[data-cart-loading]').forEach(function (el) { el.hidden = !on; });
    qsa('[data-cart-section]').forEach(function (el) { el.setAttribute('aria-busy', on ? 'true' : 'false'); });
  }

  function announce(text) {
    qsa('[data-cart-status]').forEach(function (el) { el.textContent = ''; setTimeout(function () { el.textContent = text; }, 50); });
  }

  function showCartError(msg, line) {
    var target = line ? qs('.cart-item[data-line="' + line + '"] [data-line-error]') : null;
    if (target) { target.textContent = msg; return; }
    qsa('[data-cart-error]').forEach(function (el) { el.textContent = msg; });
  }

  function clearCartErrors() {
    qsa('[data-cart-error], [data-line-error]').forEach(function (el) { el.textContent = ''; });
  }

  /* ---------- Drawer ---------- */
  function focusables(root) {
    return qsa('a[href], button:not([disabled]), input:not([disabled]), select, textarea, [tabindex]:not([tabindex="-1"])', root)
      .filter(function (el) { return el.offsetParent !== null; });
  }

  function openDrawer() {
    if (!drawer) return false;
    if (!drawer.hidden) return true;
    lastFocus = document.activeElement;
    drawer.hidden = false;
    document.body.classList.add('drawer-open');
    requestAnimationFrame(function () {
      drawer.classList.add('is-open');
      var panel = qs('.drawer__panel', drawer);
      if (panel) panel.focus();
    });
    return true;
  }

  function closeDrawer() {
    if (!drawer || drawer.hidden) return;
    drawer.classList.remove('is-open');
    document.body.classList.remove('drawer-open');
    setTimeout(function () { drawer.hidden = true; }, 280);
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  document.addEventListener('keydown', function (e) {
    if (!drawer || drawer.hidden) return;
    if (e.key === 'Escape') { closeDrawer(); return; }
    if (e.key === 'Tab') {
      var items = focusables(qs('.drawer__panel', drawer));
      if (!items.length) return;
      var first = items[0], last = items[items.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  });

  /* ---------- Cart requests ---------- */
  function parseResponse(res) {
    return res.json().then(function (data) { return { ok: res.ok, status: res.status, data: data }; });
  }

  function restoreFocus(descriptor) {
    if (!descriptor) return;
    var el = qs(descriptor);
    if (el && el.focus) el.focus();
  }

  function changeLine(line, quantity, focusSel) {
    if (busy) return;
    clearCartErrors();
    setLoading(true);
    fetch(routes.cart_change, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ line: Number(line), quantity: Number(quantity), sections: sectionIds().join(','), sections_url: window.location.pathname })
    })
      .then(parseResponse)
      .then(function (r) {
        setLoading(false);
        if (!r.ok || r.data.status) {
          showCartError(r.data.message || r.data.description || strings.error, line);
          // resynchronise le champ quantité
          return;
        }
        applySections(r.data.sections);
        setCount(r.data.item_count);
        announce(strings.updated || '');
        restoreFocus(focusSel);
      })
      .catch(function () { setLoading(false); showCartError(strings.error, line); });
  }

  function addToCart(form) {
    var btn = qs('[data-atc-button]', form);
    var errorEl = qs('[data-form-error]', form);
    if (errorEl) errorEl.textContent = '';
    if (btn) { btn.classList.add('is-loading'); btn.setAttribute('aria-disabled', 'true'); }
    var fd = new FormData(form);
    fd.append('sections', sectionIds().join(','));
    fd.append('sections_url', window.location.pathname);
    fetch(routes.cart_add, { method: 'POST', headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: fd })
      .then(parseResponse)
      .then(function (r) {
        if (!r.ok || r.data.status) {
          throw new Error(r.data.description || r.data.message || strings.error);
        }
        applySections(r.data.sections);
        return fetch(routes.cart_json, { headers: { 'Accept': 'application/json' } }).then(function (res) { return res.json(); });
      })
      .then(function (cart) {
        setCount(cart.item_count);
        announce(strings.updated || '');
        if (!openDrawer()) { window.location.href = routes.cart; }
      })
      .catch(function (err) {
        if (errorEl) errorEl.textContent = (err && err.message) || strings.error;
      })
      .then(function () {
        if (btn) { btn.classList.remove('is-loading'); btn.removeAttribute('aria-disabled'); }
      });
  }

  /* ---------- Delegated events ---------- */
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (form && form.matches && form.matches('form[data-ns-atc]')) {
      e.preventDefault();
      var btn = qs('[data-atc-button]', form);
      if (btn && (btn.disabled || btn.getAttribute('aria-disabled') === 'true')) return;
      addToCart(form);
    }
  });

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;

    var opener = t.closest('[data-cart-open]');
    if (opener && drawer && !qs('.cart-page')) {
      e.preventDefault();
      openDrawer();
      return;
    }
    if (t.closest('[data-cart-close]')) { e.preventDefault(); closeDrawer(); return; }

    var step = t.closest('[data-qty-step]');
    if (step) {
      e.preventDefault();
      var item = step.closest('.cart-item');
      var input = item && qs('[data-qty-input]', item);
      var line = step.getAttribute('data-line');
      var next = Math.max(0, (parseInt(input && input.value, 10) || 0) + parseInt(step.getAttribute('data-qty-step'), 10));
      changeLine(line, next, '.cart-item[data-line="' + line + '"] [data-qty-step="' + step.getAttribute('data-qty-step') + '"]');
      return;
    }

    var setter = t.closest('[data-qty-set]');
    if (setter) {
      e.preventDefault();
      changeLine(setter.getAttribute('data-line'), setter.getAttribute('data-qty-set'));
      return;
    }

    var rm = t.closest('[data-remove]');
    if (rm) {
      e.preventDefault();
      changeLine(rm.getAttribute('data-line'), 0);
      return;
    }

    var thumb = t.closest('[data-thumb]');
    if (thumb) {
      var id = thumb.getAttribute('data-thumb');
      var slide = qs('[data-media-id="' + id + '"]');
      if (slide) slide.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
      return;
    }

    var rec = t.closest('[data-recover-toggle]');
    if (rec) {
      e.preventDefault();
      var box = document.getElementById('recover');
      if (box) box.hidden = !box.hidden;
      return;
    }

    // ferme le menu mobile au clic extérieur
    qsa('[data-mobile-menu][open]').forEach(function (d) { if (!d.contains(t)) d.removeAttribute('open'); });
  });

  document.addEventListener('change', function (e) {
    var t = e.target;
    if (!t || !t.matches) return;
    if (t.matches('[data-qty-input]')) {
      var line = t.getAttribute('data-line');
      changeLine(line, Math.max(0, parseInt(t.value, 10) || 0), '.cart-item[data-line="' + line + '"] [data-qty-input]');
    } else if (t.matches('[data-variant-select]')) {
      onVariantChange(t);
    }
  });

  /* ---------- Variantes ---------- */
  function onVariantChange(select) {
    var form = select.closest('form');
    var json = form && qs('[data-variants]', form);
    if (!json) return;
    var variants;
    try { variants = JSON.parse(json.textContent); } catch (e) { return; }
    var v = variants.filter(function (x) { return String(x.id) === String(select.value); })[0];
    if (!v) return;
    var scope = select.closest('[data-product-section]') || document;
    var cur = qs('[data-price-current]', scope);
    if (cur) cur.textContent = money(v.price);
    var btn = qs('[data-atc-button] [data-atc-label]', form);
    var btnEl = qs('[data-atc-button]', form);
    if (btn && btnEl) {
      btnEl.disabled = !v.available;
      btn.textContent = v.available ? (strings.add || '') : (strings.sold_out || '');
    }
    qsa('[data-sticky-atc]', scope).forEach(function (b) { b.disabled = !v.available; });
    if (window.history && history.replaceState) {
      var url = new URL(window.location.href);
      url.searchParams.set('variant', v.id);
      history.replaceState({}, '', url.toString());
    }
  }

  /* ---------- Galerie + CTA collant (réinitialisable dans le Theme Editor) ---------- */
  var stickyObserver = null;

  function initGallery(root) {
    qsa('[data-gallery]', root).forEach(function (g) {
      var track = qs('[data-gallery-track]', g);
      if (!track) return;
      var ticking = false;
      track.addEventListener('scroll', function () {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(function () {
          ticking = false;
          var center = track.scrollLeft + track.clientWidth / 2;
          var best = null, bestD = Infinity;
          qsa('[data-media-id]', track).forEach(function (s) {
            var d = Math.abs(s.offsetLeft + s.offsetWidth / 2 - center);
            if (d < bestD) { bestD = d; best = s; }
          });
          if (best) {
            qsa('[data-thumb]', g).forEach(function (th) {
              th.classList.toggle('is-active', th.getAttribute('data-thumb') === best.getAttribute('data-media-id'));
            });
          }
        });
      }, { passive: true });
    });
  }

  function initSticky(root) {
    var bar = qs('[data-sticky-cta]', root);
    var buttons = qsa('form[data-ns-atc] [data-atc-button]', document);
    if (stickyObserver) { stickyObserver.disconnect(); stickyObserver = null; }
    if (!bar || !buttons.length || !('IntersectionObserver' in window)) return;
    var visible = {};
    var update = function () {
      var any = Object.keys(visible).some(function (k) { return visible[k]; });
      bar.hidden = any;
      document.body.classList.toggle('has-sticky-cta', !any);
    };
    stickyObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { visible[en.target.getAttribute('data-io-id')] = en.isIntersecting; });
      update();
    }, { threshold: 0 });
    buttons.forEach(function (b, i) { b.setAttribute('data-io-id', String(i)); visible[i] = false; stickyObserver.observe(b); });
  }

  function initProduct(root) {
    initGallery(root || document);
    initSticky(root || document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initProduct(document); });
  } else {
    initProduct(document);
  }
  document.addEventListener('shopify:section:load', function (e) { initProduct(e.target); });
  document.addEventListener('shopify:section:unload', function () { if (stickyObserver) stickyObserver.disconnect(); });
})();
